import React from 'react';

import { useHistory } from 'react-router-dom';

import { useCurrentArtistIdOrNull } from '../../../../artists';
import { Title } from '../shared';
import type { FundraisingLocationState } from '../../types';
import { AddToProfile, VSpacer48 } from '../../../Elements';

export function ArtistFundraisingPickCreate() {
  return (
    <>
      <Title />
      <AddLink />
    </>
  );
}

function AddLink() {
  const currentArtistId = useCurrentArtistIdOrNull();

  const history = useHistory<FundraisingLocationState>();
  const fundraisingFormHref = currentArtistId
    ? `${window.location.origin}/c/artist/${currentArtistId}/profile/fundraising`
    : '';

  function onClick(e: React.MouseEvent) {
    history.push(`/artist/${currentArtistId}/profile/fundraising`);
    e.preventDefault();
  }

  return (
    <>
      <AddToProfile
        text="Get support directly from fans"
        textHref={fundraisingFormHref}
        onClick={onClick}
      />
      <VSpacer48 />
    </>
  );
}
